import React, { useState } from 'react';
import { BarChart3Icon, TrendingUpIcon, DollarSignIcon, ShoppingCartIcon, UsersIcon } from 'lucide-react';
export const Statistics: React.FC = () => {
  const [timeRange, setTimeRange] = useState('month');
  // Sample data
  const salesData = {
    month: [{
      label: 'Week 1',
      value: 24500
    }, {
      label: 'Week 2',
      value: 18300
    }, {
      label: 'Week 3',
      value: 29800
    }, {
      label: 'Week 4',
      value: 23400
    }],
    quarter: [{
      label: 'Jan',
      value: 72000
    }, {
      label: 'Feb',
      value: 68000
    }, {
      label: 'Mar',
      value: 96000
    }],
    year: [{
      label: 'Q1',
      value: 236000
    }, {
      label: 'Q2',
      value: 278000
    }, {
      label: 'Q3',
      value: 304000
    }, {
      label: 'Q4',
      value: 342000
    }]
  };
  const maxValue = Math.max(...salesData[timeRange as keyof typeof salesData].map(item => item.value));
  return <div className="container mx-auto px-4 py-8" data-id="element-976">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-977">
        Statistics & Analytics
      </h1>
      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-978">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6" data-id="element-979">
          <div className="flex items-center justify-between mb-4" data-id="element-980">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-981">
              Total Revenue
            </h3>
            <span className="p-2 bg-green-100 dark:bg-green-900 rounded-md" data-id="element-982">
              <DollarSignIcon size={18} className="text-green-600 dark:text-green-400" data-id="element-983" />
            </span>
          </div>
          <div className="flex items-baseline" data-id="element-984">
            <span className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-985">
              $1,160,000
            </span>
            <span className="ml-2 text-sm font-medium text-green-600 dark:text-green-400" data-id="element-986">
              +12.5%
            </span>
          </div>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-987">
            Compared to last year
          </p>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6" data-id="element-988">
          <div className="flex items-center justify-between mb-4" data-id="element-989">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-990">
              Orders
            </h3>
            <span className="p-2 bg-blue-100 dark:bg-blue-900 rounded-md" data-id="element-991">
              <ShoppingCartIcon size={18} className="text-blue-600 dark:text-blue-400" data-id="element-992" />
            </span>
          </div>
          <div className="flex items-baseline" data-id="element-993">
            <span className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-994">
              4,287
            </span>
            <span className="ml-2 text-sm font-medium text-green-600 dark:text-green-400" data-id="element-995">
              +8.3%
            </span>
          </div>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-996">
            Compared to last year
          </p>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6" data-id="element-997">
          <div className="flex items-center justify-between mb-4" data-id="element-998">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-999">
              Avg. Order Value
            </h3>
            <span className="p-2 bg-yellow-100 dark:bg-yellow-900 rounded-md" data-id="element-1000">
              <TrendingUpIcon size={18} className="text-yellow-600 dark:text-yellow-400" data-id="element-1001" />
            </span>
          </div>
          <div className="flex items-baseline" data-id="element-1002">
            <span className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-1003">
              $270.58
            </span>
            <span className="ml-2 text-sm font-medium text-green-600 dark:text-green-400" data-id="element-1004">
              +3.7%
            </span>
          </div>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-1005">
            Compared to last year
          </p>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6" data-id="element-1006">
          <div className="flex items-center justify-between mb-4" data-id="element-1007">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1008">
              Active Customers
            </h3>
            <span className="p-2 bg-purple-100 dark:bg-purple-900 rounded-md" data-id="element-1009">
              <UsersIcon size={18} className="text-purple-600 dark:text-purple-400" data-id="element-1010" />
            </span>
          </div>
          <div className="flex items-baseline" data-id="element-1011">
            <span className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-1012">
              12,845
            </span>
            <span className="ml-2 text-sm font-medium text-green-600 dark:text-green-400" data-id="element-1013">
              +15.2%
            </span>
          </div>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-1014">
            Compared to last year
          </p>
        </div>
      </div>
      {/* Sales Chart */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6 mb-8" data-id="element-1015">
        <div className="flex justify-between items-center mb-6" data-id="element-1016">
          <div className="flex items-center" data-id="element-1017">
            <BarChart3Icon size={20} className="text-gray-500 dark:text-gray-400 mr-2" data-id="element-1018" />
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-1019">
              Sales Overview
            </h3>
          </div>
          <select value={timeRange} onChange={e => setTimeRange(e.target.value)} className="border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-500" data-id="element-1020">
            <option value="month" data-id="element-1021">This Month</option>
            <option value="quarter" data-id="element-1022">This Quarter</option>
            <option value="year" data-id="element-1023">This Year</option>
          </select>
        </div>
        <div className="h-64" data-id="element-1024">
          <div className="flex h-full items-end" data-id="element-1025">
            {salesData[timeRange as keyof typeof salesData].map((item, index) => <div key={index} className="flex-1 flex flex-col items-center" data-id="element-1026">
                  <div className="w-full bg-yellow-500 rounded-t-md mx-1" style={{
              height: `${item.value / maxValue * 100}%`
            }} data-id="element-1027"></div>
                  <div className="mt-2 text-xs text-gray-600 dark:text-gray-400" data-id="element-1028">
                    {item.label}
                  </div>
                  <div className="mt-1 text-xs font-medium text-gray-900 dark:text-white" data-id="element-1029">
                    ${(item.value / 1000).toFixed(1)}k
                  </div>
                </div>)}
          </div>
        </div>
      </div>
      {/* Sales by Category */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-1030">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6" data-id="element-1031">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6" data-id="element-1032">
            Sales by Category
          </h3>
          <div className="space-y-4" data-id="element-1033">
            <div data-id="element-1034">
              <div className="flex justify-between mb-1" data-id="element-1035">
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-1036">
                  Electronics
                </span>
                <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1037">
                  $485,200
                </span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2" data-id="element-1038">
                <div className="bg-blue-500 h-2 rounded-full" style={{
                width: '42%'
              }} data-id="element-1039"></div>
              </div>
              <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1040">
                42% of total sales
              </span>
            </div>
            <div data-id="element-1041">
              <div className="flex justify-between mb-1" data-id="element-1042">
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-1043">
                  Gold
                </span>
                <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1044">
                  $348,600
                </span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2" data-id="element-1045">
                <div className="bg-yellow-500 h-2 rounded-full" style={{
                width: '30%'
              }} data-id="element-1046"></div>
              </div>
              <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1047">
                30% of total sales
              </span>
            </div>
            <div data-id="element-1048">
              <div className="flex justify-between mb-1" data-id="element-1049">
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-1050">
                  Silver
                </span>
                <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1051">
                  $185,600
                </span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2" data-id="element-1052">
                <div className="bg-gray-500 h-2 rounded-full" style={{
                width: '16%'
              }} data-id="element-1053"></div>
              </div>
              <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1054">
                16% of total sales
              </span>
            </div>
            <div data-id="element-1055">
              <div className="flex justify-between mb-1" data-id="element-1056">
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-1057">
                  Technical Tools
                </span>
                <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1058">
                  $81,200
                </span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2" data-id="element-1059">
                <div className="bg-green-500 h-2 rounded-full" style={{
                width: '7%'
              }} data-id="element-1060"></div>
              </div>
              <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1061">
                7% of total sales
              </span>
            </div>
            <div data-id="element-1062">
              <div className="flex justify-between mb-1" data-id="element-1063">
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-1064">
                  Platinum
                </span>
                <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1065">
                  $58,000
                </span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2" data-id="element-1066">
                <div className="bg-purple-500 h-2 rounded-full" style={{
                width: '5%'
              }} data-id="element-1067"></div>
              </div>
              <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1068">
                5% of total sales
              </span>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6" data-id="element-1069">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6" data-id="element-1070">
            Top Selling Products
          </h3>
          <div className="divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1071">
            <div className="py-3 flex justify-between items-center" data-id="element-1072">
              <div data-id="element-1073">
                <h4 className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1074">
                  MacBook Pro 2021
                </h4>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1075">
                  Electronics
                </p>
              </div>
              <div className="text-right" data-id="element-1076">
                <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1077">
                  $168,700
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1078">
                  130 units
                </p>
              </div>
            </div>
            <div className="py-3 flex justify-between items-center" data-id="element-1079">
              <div data-id="element-1080">
                <h4 className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1081">
                  Gold Bar 1oz
                </h4>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1082">Gold</p>
              </div>
              <div className="text-right" data-id="element-1083">
                <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1084">
                  $145,880
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1085">
                  70 units
                </p>
              </div>
            </div>
            <div className="py-3 flex justify-between items-center" data-id="element-1086">
              <div data-id="element-1087">
                <h4 className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1088">
                  iPhone 13 Pro
                </h4>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1089">
                  Electronics
                </p>
              </div>
              <div className="text-right" data-id="element-1090">
                <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1091">
                  $119,880
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1092">
                  120 units
                </p>
              </div>
            </div>
            <div className="py-3 flex justify-between items-center" data-id="element-1093">
              <div data-id="element-1094">
                <h4 className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1095">
                  Canon EOS R6
                </h4>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1096">
                  Electronics
                </p>
              </div>
              <div className="text-right" data-id="element-1097">
                <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1098">
                  $87,465
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1099">
                  35 units
                </p>
              </div>
            </div>
            <div className="py-3 flex justify-between items-center" data-id="element-1100">
              <div data-id="element-1101">
                <h4 className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1102">
                  Silver Eagle 2023
                </h4>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1103">
                  Silver
                </p>
              </div>
              <div className="text-right" data-id="element-1104">
                <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1105">
                  $70,000
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1106">
                  2,000 units
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6" data-id="element-1107">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6" data-id="element-1108">
          Traffic Sources
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1109">
          <div className="bg-gray-50 dark:bg-gray-900 rounded-lg p-4" data-id="element-1110">
            <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-1111">
              Direct
            </h4>
            <p className="text-xl font-bold text-gray-900 dark:text-white mb-1" data-id="element-1112">
              42%
            </p>
            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5" data-id="element-1113">
              <div className="bg-blue-500 h-1.5 rounded-full" style={{
              width: '42%'
            }} data-id="element-1114"></div>
            </div>
          </div>
          <div className="bg-gray-50 dark:bg-gray-900 rounded-lg p-4" data-id="element-1115">
            <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-1116">
              Organic Search
            </h4>
            <p className="text-xl font-bold text-gray-900 dark:text-white mb-1" data-id="element-1117">
              28%
            </p>
            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5" data-id="element-1118">
              <div className="bg-green-500 h-1.5 rounded-full" style={{
              width: '28%'
            }} data-id="element-1119"></div>
            </div>
          </div>
          <div className="bg-gray-50 dark:bg-gray-900 rounded-lg p-4" data-id="element-1120">
            <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-1121">
              Social Media
            </h4>
            <p className="text-xl font-bold text-gray-900 dark:text-white mb-1" data-id="element-1122">
              18%
            </p>
            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5" data-id="element-1123">
              <div className="bg-purple-500 h-1.5 rounded-full" style={{
              width: '18%'
            }} data-id="element-1124"></div>
            </div>
          </div>
          <div className="bg-gray-50 dark:bg-gray-900 rounded-lg p-4" data-id="element-1125">
            <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-1126">
              Referrals
            </h4>
            <p className="text-xl font-bold text-gray-900 dark:text-white mb-1" data-id="element-1127">
              12%
            </p>
            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5" data-id="element-1128">
              <div className="bg-yellow-500 h-1.5 rounded-full" style={{
              width: '12%'
            }} data-id="element-1129"></div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};